<template>
    <div>

        <div class="table-tools">
            <a-form layout="inline" >
                <a-form-item >
                    <station-select @changeStation="getStation"></station-select>
                </a-form-item>
                <a-form-item >
                    <a-input placeholder="逆变器名称" v-model="stationName"></a-input>
                </a-form-item>
                <a-form-item>
                    <a-button-group>
                        <a-button type="primary" @click="initTable"><i class="fa fa-search icon"></i> 搜索</a-button>
                        <a-button @click="exportData"> <i class="fa fa-cloud-download icon"></i> 导出</a-button>
                    </a-button-group>
                </a-form-item>
            </a-form>


            <div class="table-tools-right">
                <a-icon type="sync" />
                <table-columns :columns="columns" @getFilterColumns="getColumns" :rowKey="record=>record.id">
                </table-columns>
            </div>
        </div>
        <a-table :loading="loading"
                 :columns="filterColumns"
                 :dataSource="data"
                 bordered
                 @change="changeOrder"
                 :pagination="pagination"

                 :scroll="{ x: '150%'}"
                 :customRow="(record) => {
                            return {
                                on: { // 事件
                                    click: () => {
                                        onSelectChange(record)
                                    }
                                },
                             }}"

        >
                   <span slot="id" slot-scope="text, record, index">
                        <template>
                            <span>{{index + 1}}</span>
                        </template>
                  </span>
        </a-table>
    </div>
</template>

<script>

    import TableColumns from "@/components/TableColumn/TableColumns";
    import stationSelect from "../../common/stationSelect";

    const columns = [
        {
            title: 'id',
            key: 'inverterId',
            dataIndex: 'inverterId',
            show: true,
            sorter: true,
            scopedSlots: {customRender: "id"},
        },
        {
            title: '场站名称',
            key: 'powerStationName',
            dataIndex: 'powerStationName',
            show: true,
            sorter: true
        },
        {
            title: '逆变器名',
            key: 'inverterName',
            dataIndex: 'inverterName',
            show: true,
            sorter: true
        },
        {
            title: '总发电量(kWh)',
            key: 'totalElecCap',
            dataIndex: 'totalElecCap',
            show: true,
            sorter: true
        },
        {
            title: '总发电小时(h)',
            key: 'totalElecHour',
            dataIndex: 'totalElecHour',
            show: true,
            sorter: true
        },
        {
            title: '年发电量(kWh)',
            key: 'yearElecCap',
            dataIndex: 'yearElecCap',
            show: true,
            sorter: true
        },
        {
            title: '年发电小时(h)',
            key: 'yearElecHour',
            dataIndex: 'yearElecHour',
            show: true,
            sorter: true
        },
        {
            title: '月发电量(kWh)',
            key: 'monthElecCap',
            dataIndex: 'monthElecCap',
            show: true,
            sorter: true
        },
        {
            title: '月发电小时(h)',
            key: 'monthElecHour',
            dataIndex: 'monthElecHour',
            show: true,
            sorter: true
        },
        {
            title: '日发电量(kWh)',
            key: 'dayElecCap',
            dataIndex: 'dayElecCap',
            show: true,
            sorter: true
        },
        {
            title: '日发电小时(h)',
            key: 'dayElecHour',
            dataIndex: 'dayElecHour',
            show: true,
            sorter: true
        },
        {
            title: '逆变器PR(%)',
            key: 'inverterPR',
            dataIndex: 'inverterPR',
            show: true,
            sorter: true
        },
        {
            title: '总运行时间(h)',
            key: 'totalRunTime',
            dataIndex: 'totalRunTime',
            show: true,
            sorter: true
        },
        {
            title: '组件容量(kWp)',
            key: 'capacity',
            dataIndex: 'capacity',
            show: true,
            sorter: true
        },
        {
            title: '环境温度(°C)',
            key: 'pasterTemp',
            dataIndex: 'pasterTemp',
            show: true,
            sorter: true
        },
        {
            title: '采集时间',
            key: 'createTime',
            dataIndex: 'createTime',
            show: true,
            sorter: true
        },
        {
            title: '设备序列号',
            key: 'sequence',
            dataIndex: 'sequence',
            show: false,
            sorter: true
        },
        {
            title: '地址',
            key: 'slaveAddr',
            dataIndex: 'slaveAddr',
            show: false,
            sorter: true
        },
        {
            title: '设备类型',
            key: 'deviceTypeName',
            dataIndex: 'deviceTypeName',
            show: false,
            sorter: true
        },
        {
            title: '额定输出功率',
            key: 'rateOutputPower',
            dataIndex: 'rateOutputPower',
            show: false,
            sorter: true
        },
        {
            title: '输出类型',
            key: 'outputTypeName',
            dataIndex: 'outputTypeName',
            show: false,
            sorter: true
        },
        {
            title: '机内温度(°C)',
            key: 'interTemp',
            dataIndex: 'interTemp',
            show: false,
            sorter: true
        },
        {
            title: '直流电压1(V)',
            key: 'vdc1',
            dataIndex: 'vdc1',
            show: false,
            sorter: true
        },
        {
            title: '直流电流1(A)',
            key: 'idc1',
            dataIndex: 'idc1',
            show: false,
            sorter: true
        },
        {
            title: '直流电压2(V)',
            key: 'vdc2',
            dataIndex: 'vdc2',
            show: false,
            sorter: true
        },
        {
            title: '设备序列号',
            key: 'sequence',
            dataIndex: 'sequence',
            show: false,
            sorter: true
        },
        {
            title: '直流电流2(A)',
            key: 'idc2',
            dataIndex: 'idc2',
            show: false,
            sorter: true
        },
        {
            title: '直流电压3(V)',
            key: 'vdc3',
            dataIndex: 'vdc3',
            show: false,
            sorter: true
        },
        {
            title: '直流电流3(A)',
            key: 'idc3',
            dataIndex: 'idc3',
            show: false,
            sorter: true
        },
        {
            title: '直流电压4(V)',
            key: 'vdc4',
            dataIndex: 'vdc4',
            show: false,
            sorter: true
        },
        {
            title: '直流电流4(A)',
            key: 'idc4',
            dataIndex: 'idc4',
            show: false,
            sorter: true
        },
        {
            title: '总直流功率(W)',
            key: 'totalDCPower',
            dataIndex: 'totalDCPower',
            show: false,
            sorter: true
        },
        {
            title: 'A-B线电压/A相电压(V)',
            key: 'lineVABorPhaseVA',
            dataIndex: 'lineVABorPhaseVA',
            show: false,
            sorter: true
        },
        {
            title: 'B-C线电压/B相电压(V)',
            key: 'lineVBCorPhaseVB',
            dataIndex: 'lineVBCorPhaseVB',
            show: false,
            sorter: true
        },
        {
            title: 'C-A线电压/C相电压(V)',
            key: 'lineVCAorPhaseVC',
            dataIndex: 'lineVCAorPhaseVC',
            show: false,
            sorter: true
        },
        {
            title: 'A相电流(A)',
            key: 'phaseIA',
            dataIndex: 'phaseIA',
            show: false,
            sorter: true
        },
        {
            title: 'B相电流(A)',
            key: 'phaseIB',
            dataIndex: 'phaseIB',
            show: false,
            sorter: true
        },
        {
            title: 'C相电流(A)',
            key: 'phaseIC',
            dataIndex: 'phaseIC',
            show: false,
            sorter: true
        },
        {
            title: '总有功功率(W)',
            key: 'totalActivePower',
            dataIndex: 'totalActivePower',
            show: false,
            sorter: true
        },
        {
            title: '无功功率(var)',
            key: 'idlePower',
            dataIndex: 'idlePower',
            show: false,
            sorter: true
        },
        {
            title: '功率因素',
            key: 'pf',
            dataIndex: 'pf',
            show: false,
            sorter: true
        },
        {
            title: '电网频率',
            key: 'fac',
            dataIndex: 'fac',
            show: false,
            sorter: true
        },
        {
            title: '设备工作状态',
            key: 'deviceRunStatusName',
            dataIndex: 'deviceRunStatusName',
            show: false,
            sorter: true
        },
        {
            title: '告警 年',
            key: 'alarmYear',
            dataIndex: 'alarmYear',
            show: false,
            sorter: true
        },
        {
            title: '告警 月',
            key: 'alarmMonth',
            dataIndex: 'alarmMonth',
            show: false,
            sorter: true
        },
        {
            title: '告警 日',
            key: 'alarmDay',
            dataIndex: 'alarmDay',
            show: false,
            sorter: true
        },
        {
            title: '告警 时',
            key: 'alarmHour',
            dataIndex: 'alarmHour',
            show: false,
            sorter: true
        },
        {
            title: '告警 分',
            key: 'alarmMinute',
            dataIndex: 'alarmMinute',
            show: false,
            sorter: true
        },
        {
            title: '告警 秒',
            key: 'alarmSecond',
            dataIndex: 'alarmSecond',
            show: false,
            sorter: true
        },
        {
            title: '告警代码',
            key: 'alarmCode',
            dataIndex: 'alarmCode',
            show: false,
            sorter: true
        },
        {
            title: '额定无功输出功率(kVar)',
            key: 'rateIdleOutputPower',
            dataIndex: 'rateIdleOutputPower',
            show: false,
            sorter: true
        },
        {
            title: '并联对地阻抗(kΩ)',
            key: 'parallelingToGroundImpedance',
            dataIndex: 'parallelingToGroundImpedance',
            show: false,
            sorter: true
        },
        {
            title: '负极对地电压',
            key: 'cathodeToGroundV',
            dataIndex: 'cathodeToGroundV',
            show: false,
            sorter: true
        },
        {
            title: '母线电压',
            key: 'generatrixV',
            dataIndex: 'generatrixV',
            show: false,
            sorter: true
        },
        {
            title: '电网频率2',
            key: 'fac2',
            dataIndex: 'fac2',
            show: false,
            sorter: true
        },
        {
            title: '第一路电流',
            key: 'i1',
            dataIndex: 'i1',
            show: false,
            sorter: true
        },
        {
            title: '第二路电流',
            key: 'i2',
            dataIndex: 'i2',
            show: false,
            sorter: true
        },
        {
            title: '第三路电流',
            key: 'i3',
            dataIndex: 'i3',
            show: false,
            sorter: true
        },
        {
            title: '第四路电流',
            key: 'i4',
            dataIndex: 'i4',
            show: false,
            sorter: true
        },
        {
            title: '第五路电流',
            key: 'i5',
            dataIndex: 'i5',
            show: false,
            sorter: true
        },
        {
            title: '第六路电流',
            key: 'i6',
            dataIndex: 'i6',
            show: false,
            sorter: true
        },
        {
            title: '第七路电流',
            key: 'i7',
            dataIndex: 'i7',
            show: false,
            sorter: true
        },
        {
            title: '第八路电流',
            key: 'i8',
            dataIndex: 'i8',
            show: false,
            sorter: true
        },
        {
            title: '第九路电流',
            key: 'i9',
            dataIndex: 'i9',
            show: false,
            sorter: true
        },
        {
            title: '第十路电流',
            key: 'i10',
            dataIndex: 'i10',
            show: false,
            sorter: true
        },
        {
            title: '第十一路电流',
            key: 'i11',
            dataIndex: 'i11',
            show: false,
            sorter: true
        },
        {
            title: '第十二路电流',
            key: 'i12',
            dataIndex: 'i12',
            show: false,
            sorter: true
        },
        {
            title: '第十三路电流',
            key: 'i13',
            dataIndex: 'i13',
            show: false,
            sorter: true
        },
        {
            title: '第十四路电流',
            key: 'i14',
            dataIndex: 'i14',
            show: false,
            sorter: true
        },
        {
            title: '第十五路电流',
            key: 'i15',
            dataIndex: 'i15',
            show: false,
            sorter: true
        },
        {
            title: '第十六路电流',
            key: 'i16',
            dataIndex: 'i16',
            show: false,
            sorter: true
        },
        {
            title: '第十七路电流',
            key: 'i17',
            dataIndex: 'i17',
            show: false,
            sorter: true
        },
        {
            title: '第十八路电流',
            key: 'i18',
            dataIndex: 'i18',
            show: false,
            sorter: true
        }

    ];
    export default {
        name: "inverterTable",
        components:{
            TableColumns,
            stationSelect
        },
        data(){
            return {
                labelCol: {
                    span: 12
                },
                columns,
                type: 0,
                data: [],
                filterColumns:[],
                queryParam:{
                    station: ''
                },
                selectData: {
                    station: [
                        {
                            id: 1,
                            name: 'haha'
                        }
                    ]
                },
                queryParams:{
                    sortName: 'id',
                    sortOrder: 'asc',
                    page: 1,
                    size: 10
                },
                order: {
                    ascend: 'asc',
                    descend: 'desc'
                },
                loading: false,
                stationName: '',
                pagination: {
                    total: 0,
                    current: 1,
                    // defaultPageSize: 10,
                    showSizeChanger: true,
                    pageSizeOptions: ['10','20','50','100']
                },
                groupId: 0,
                stationId: 0,
                username: null
            }
        },
        mounted(){
            this.username = this.$Utils.getUserStorage().username;
            this.groupId = this.$Utils.getUserStorage().groupId;
            this.initTableColumns();
            this.loadTable();
        },
        methods:{
            initTableColumns(){
                this.filterColumns = this.columns.filter(item => item.show);
            },
            initData(){
                this.loadStatus();
            },
            getColumns(data){
                this.filterColumns = data;
            },

            getStation(id){
                this.stationId = id;
                this.initTable();
            },

            loadTable(type = 0){
                this.type = type;
                this.initTable();
            },

            async initTable(){
                this.loading = true;
                let result = await this.$http.get(this.$baseURL.inverterTablePageInfo({groupId: this.groupId, powerStationId: this.stationId, runStatusId: this.type, inverterName: this.stationName}, this.queryParams))
                console.log(result)
                this.data = result.list;
                this.pagination.current = result.pageNum;
                this.pagination.total = result.total;
                this.loading = false;

                console.log(this.pagination)
            },

            changeOrder(pagination, filters, sorter){
                console.log(pagination ,sorter)
                this.queryParams.page = pagination.current;
                this.queryParams.sortName = sorter.columnKey ? sorter.columnKey : 'id';
                this.queryParams.sortOrder = sorter.order ? this.order[sorter.order] : 'asc';
                this.initTable()
            },
            onSelectChange(obj){
                console.log(obj)
                //this.detail = !this.detail;
                //this.$refs.stationDetail.init(obj);
                this.$emit('selectInverterDetail', obj)
            },

            async exportData(){
                let result = await this.$http.get(this.$baseURL.inverterExportExcel({groupId: this.groupId, powerStationId: this.stationId, username: this.username}), 1)
                this.$Utils.showInfo({title: '文件下载', msg: '生成文件需要一点时间,完成后会自动下载...'})
            }
        },
        computed:{
            wrapperCol(){
                return {span: 24 - this.labelCol.span};
            }
        }
    }
</script>

<style scoped>
    .icon {
        margin-right: 5px;
    }
</style>
